/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { _ as __assign } from '../../../tslib.es6-e01eabb2.js';
import { as as env } from '../../../index-f24a9ec1.js';
import { DDCall } from '../../../bridges/dd/index.js';
import { WVCall } from '../../../bridges/windvane/index.js';
import { NBCall } from '../../../bridges/nebula/index.js';
import { PanguMiniAppCall } from '../../../bridges/pangu-mini-app/index.js';
import { E as ErrorCodes } from '../../../constants-163bd007.js';
import '../../../index-6f6b9acc.js';
import { l as logError } from '../../../log-aabf3a34.js';
import '../../../loadscripts-cf212b8d.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../index.es-142c5680.js';
import '../../../_commonjsHelpers-56d33373.js';

var notSupport = function (_a) {
    var fail = _a.fail;
    fail === null || fail === void 0 ? void 0 : fail({
        errCode: ErrorCodes.NotSupport,
        errMsg: 'not support',
    });
};
/**
 * 提供统一的promise规范能力。所有标准API，都返回promise
 * 能力扩展： promisify + context
 * TODO: context设计为插件，可供注入
 */
function promisifyApi(apiFn, context) {
    // 这里嵌套深，为了代码可读性，先禁用这条eslint规则
    // eslint-disable-next-line arrow-body-style
    var promisify = function (fn) {
        return function (params) {
            return new Promise(function (resolve, reject) {
                var success = function (e) {
                    // @ts-ignore 这里success是IOptions参数值，如果用户传入，则执行用户success
                    if (typeof (params === null || params === void 0 ? void 0 : params.success) === 'function') {
                        // @ts-ignore 同上
                        params === null || params === void 0 ? void 0 : params.success(e);
                    }
                    else {
                        resolve(e);
                    }
                };
                var fail = function (e) {
                    // @ts-ignore 这里fail是IOptions参数值，如果用户传入，则执行用户fail
                    if (typeof (params === null || params === void 0 ? void 0 : params.fail) === 'function') {
                        // @ts-ignore 同上
                        params.fail(e);
                    }
                    reject(e);
                    // 错误机制
                    logError(JSON.stringify(e));
                };
                // 增加fn能力，具备promise规范 + context能力
                var promisifyApiParams = { success: success, fail: fail };
                var enhanceParams = __assign(__assign({}, params), promisifyApiParams);
                fn(enhanceParams, context);
            });
        };
    };
    var api = promisify(apiFn);
    return api;
}

// promisifyApi 扩展参数能力
var injectPromisifyAndContextApi = function (api) {
    var context = {
        WVCall: WVCall,
        NBCall: NBCall,
        DDCall: DDCall,
        PanguMiniAppCall: PanguMiniAppCall,
    };
    return promisifyApi(api, context);
};
/**
 * 判端核心规则：使用对象{}方式，代替if else判端。
 * 原理是：使用递归对象 + 判端环境，优先匹配到环境后，执行对应环境的函数。如果都没匹配到，执行基础函数extendBaseFunction。
 * @param apiConfig 各端的对象{}，匹配上则执行。
 * @param extendBaseFunction 扩展的基础api，没匹配则执行该函数【可选】
 * @param envConfig 判端规则，代替if else
 * @returns
 */
function register(apiConfig, extendBaseFunction, envConfig) {
    /**
     * 代码流程：
     * 1. 根据isXxx约定规则，找到端函数api。
     * 2. 把api，自动注入promisify和context能力。
     * 注意：api赋值是覆盖式。即当同时2个端符合env条件（一般不会发生），以最后1个端实现为准。
     */
    var api = null;
    Object.keys(apiConfig).forEach(function (client) {
        // @ts-ignore 同上TODO，apiConfig[client]定义合理类型？
        return traverseRecursively(client, apiConfig[client]);
    });
    //  优先级
    if (api) {
        return injectPromisifyAndContextApi(api);
    }
    if (extendBaseFunction) {
        return extendBaseFunction;
    }
    return injectPromisifyAndContextApi(notSupport);
    // @ts-ignore TODO envEntities定义合理类型？
    function traverseRecursively(key, envEntities) {
        var mergedEnv = __assign(__assign({}, env), envConfig);
        var envKey = key.replace(/^\S/, function (s) { return s.toUpperCase(); });
        // @ts-ignore 判端核心规则：根据is + 端名，将if 转为 apiConfig方式。TODO 找到好的方式解决TS类型
        var isEnv = mergedEnv["is".concat(envKey)];
        if (typeof isEnv === 'function' ? isEnv() : isEnv) {
            if (typeof envEntities === 'function') {
                api = envEntities;
                return;
            }
            if (envEntities) {
                Object.keys(envEntities).forEach(function (nestKey) {
                    // first letter uppercase
                    var envNestKey = nestKey.replace(/^\S/, function (s) { return s.toUpperCase(); });
                    var entity = envEntities[nestKey];
                    // @ts-ignore 同上TODO
                    var isNestEnv = mergedEnv["is".concat(envNestKey)];
                    if (typeof isNestEnv === 'function' ? isNestEnv() : isNestEnv) {
                        traverseRecursively(nestKey, entity);
                    }
                });
            }
        }
    }
}

export { register as default };
